import React, { useEffect } from "react"
import "normalize.css"
import "./layout.css"
import { useStaticQuery, graphql } from "gatsby"
import Navbar from "./Navbar"
import ScrollToTop from "./ScrollToTop"

const query = graphql`
  {
    info: contentfulWebsiteGeneralInformation {
      logoName
      iconColor
      themeColor
    }
  }
`
const Layout = ({ children }) => {
  const data = useStaticQuery(query)

  const {
    info: { logoName, iconColor, themeColor },
  } = data

  useEffect(() => {
    const root = document.querySelector(":root")

    root.style.setProperty("--hue-color", themeColor)

    root.style.setProperty(
      "--icon-color",
      iconColor ||
        "invert(32%) sepia(49%) saturate(4334%) hue-rotate(238deg) brightness(96%) contrast(83%)"
    )

    const navLink = document.querySelectorAll(".page_links")

    navLink.forEach(navItem => {
      navItem.addEventListener("click", () => {
        document
          .querySelector(":root")
          .style.setProperty("--scroll-behavior", "auto")
      })
    })
  }, [themeColor, iconColor])

  return (
    <div>
      <Navbar className="top" logo={logoName} />
      {children}
      <ScrollToTop />
    </div>
  )
}

export default Layout
